import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 所有分享给本公司(运价)信息的tenant(不是TenantSharing)，包含本公司
export function queryAllInviteTenants(params) {
  return request({
    url: URL.price.tenantSharing.queryAllInviteTenants,
    method: 'post',
    params
  })
}
// 运价分享-列表查询
export function getTenantSharings(params) {
  return request({
    url: URL.price.tenantSharing.getTenantSharings,
    method: 'post',
    params
  })
}
// 运价分享-保存
export function saveMe(data) {
  return request({
    url: URL.price.tenantSharing.saveMe,
    method: 'post',
    data
  })
}
// 运价分享-更新
export function updatePoint(data) {
  return request({
    url: URL.price.tenantSharing.updatePoint,
    method: 'post',
    data
  })
}
// 运价分享-更新
export function accept(data) {
  return request({
    url: URL.price.tenantSharing.accept,
    method: 'post',
    data
  })
}
// 运价分享-更新
export function updateCheckState(data) {
  return request({
    url: URL.price.tenantSharing.updateCheckState,
    method: 'post',
    data
  })
}

// 运价分享-撤销同意
export function cancelAgree(data) {
  return request({
    url: URL.price.tenantSharing.cancelAgree,
    method: 'post',
    data
  })
}

// 获取当前租户的所有的运价分享策略
export function getTenantSharingPriceProfile() {
  return request({
    url: URL.price.tenantSharing.getTenantSharingPriceProfile,
    method: 'get'
  })
}
